"use strict";

var _classCallCheck = require("/Users/yonghui/toolchain/muta-wallet/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/yonghui/toolchain/muta-wallet/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var account_1 = require("./account");

var constant_1 = require("./core/constant");

var index_1 = require("./index");

var wallet_1 = require("./wallet");
/**
 * Main module of the SDK
 */


var Muta =
/*#__PURE__*/
function () {
  function Muta(context) {
    _classCallCheck(this, Muta);

    this.context = {
      chainId: context.chainId,
      endpoint: context.endpoint,
      timeoutGap: constant_1.DEFAULT_TIMEOUT_GAP
    };
  }

  _createClass(Muta, [{
    key: "hdWalletFromMnemonic",

    /**
     * create a HD wallet from mnemonic
     * @param mnemonic 12 mnemonic words
     */
    value: function hdWalletFromMnemonic(mnemonic) {
      return wallet_1.HDWallet.fromMnemonic(mnemonic);
    }
    /**
     * create a account from private key
     * @param privateKey
     */

  }, {
    key: "accountFromPrivateKey",
    value: function accountFromPrivateKey(privateKey) {
      return account_1.SyncAccount.fromPrivateKey(privateKey);
    }
  }, {
    key: "client",
    get: function get() {
      var _this$context = this.context,
          endpoint = _this$context.endpoint,
          chainId = _this$context.chainId;
      return new index_1.Client(endpoint, chainId);
    }
  }]);

  return Muta;
}();

exports.Muta = Muta;